export default "__VITE_ASSET__BYmIPB0g__"